import type { ArtifactExportOption } from "./ArtifactExportMenu";
import type { ArtifactExportFormat } from "./useArtifactExport";

/** Export formats per artifact kind, shared by the cards and by the collapsed
 *  header (ArtifactCard), so both offer the same menu. */

/** A markdown file exports to Word and PDF: the export route reads it into the
 *  document IR (`markdown_to_ir`). Other text files have no such reader, so they
 *  get no menu rather than a button that always fails. */
export const MARKDOWN_EXPORT_FORMATS = [
  { fmt: "docx", label: "Word (.docx)" },
  { fmt: "pdf", label: "PDF" },
] as const;

export const TABLE_EXPORT_FORMATS = [
  { fmt: "xlsx", label: "Excel (.xlsx)" },
  { fmt: "pdf", label: "PDF" },
] as const;

const FORMAT_LABELS: Record<ArtifactExportFormat, string> = {
  docx: "Word (.docx)",
  pdf: "PDF",
  xlsx: "Excel (.xlsx)",
  pptx: "PowerPoint (.pptx)",
  html: "HTML",
};

/** The menu for an artifact: its kind's `defaults`, or, when the backend
 *  tool set `allowed` (the artifact's export_formats), exactly those in that
 *  order. The export route refuses anything else, so offering a default the
 *  list leaves out would be a button that always fails. Unknown formats are
 *  dropped. */
export function exportFormatsFor(
  defaults: readonly ArtifactExportOption[],
  allowed: readonly string[] | undefined,
): readonly ArtifactExportOption[] {
  if (!allowed) return defaults;
  return allowed
    .filter((f): f is ArtifactExportFormat => f in FORMAT_LABELS)
    .map((fmt) => ({ fmt, label: FORMAT_LABELS[fmt] }));
}
